<template>
    <div id="summaryGraphModal" v-show="show">
        <div id="imageArray">
            <img src="../assets/art/math_tool/summary_graph/barPlot.png" v-on:click="openExe('barPlot')">
            <img src="../assets/art/math_tool/summary_graph/boxPlot.png" v-on:click="openExe('boxPlot')">
            <img src="../assets/art/math_tool/summary_graph/circlePlot.png" v-on:click="openExe('circlePlot')">
            <img src="../assets/art/math_tool/summary_graph/summary_graph.png" v-on:click="openExe('ljcs')">
            <img id="exitModal" src="../assets/art/math_tool/summary_graph/關閉.svg" v-on:click="closeModal()">
        </div>
    </div>
</template>
<script>

import AppRenderer from "../js/app_renderer";
import BookData from "../js/book_data";

export default {
    name: 'app',
    data() {
        return {
            show: false,
        };
    },
    methods: {
        openExe(type) {
            AppRenderer.Instance.openFile(BookData.Instance.getItemPath() + "統計圖/" + type + ".exe");
        },
        closeModal() {
            this.show = false;
        }
    },
    mounted: function () {
    }
}
</script>

<style >
#summaryGraphModal {
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: rgb(0, 102, 203);
    padding: 0.5rem;
    z-index: 9999;
    transform: translate(-50%, -50%) scale(var(--window-scale));
}

#imageArray {
    position: relative;
    border-radius: 1em;
    background-color: #ffffff;
}

#exitModal {
    position: relative;
    top: -2.5em;
}


/* 
#titleModal {
  position: relative;
  width: auto;
  top: -1.5em;
  height: 1.5em;

}

#textTitle {
  top: 0em;
  font-size: 1.5em;
  text-align: center;
}

.ck-editor__editable_inline {
  height: 27em !important;
}

.ck-list {
  height: 27em !important;
  overflow-y: auto !important;
}

#stickyModal {
  position: absolute;
  top: calc(50% - 300px);
  left: calc(50% - 400px);
  background-color: white;
  width: 50em;
  height: 37.5em;
  border: 0.5em solid #3db39d;
  border-radius: .5rem;
  z-index: var(--z-index-sticky);
}

#stickyModal .title {
  margin-top: -1.5em;
}

#stickyModal .title img {
  float: right;
  width: 2.5em;
  margin-right: -1.5em;
}

#stickyModal .text-editor {
  background-color: #3db39d;
}

.stickyModalTool {
  height: 4em;
}

.stickyModalTool img {
  float: right;
}

#stickyModal .buttons {
  position: absolute;
  bottom: 0em;
  right: 0em;
}

.text-editor {
  display: flex;
  justify-content: space-around;
}

.stickyModalToolButton {
  height: 4em;
}

.stickyModalTextArea {
  height: calc(100%);
} */
</style>
